import { BlockedValueModalTranslations } from "./blocked-value-modal-pt-br";

export const BLOCKED_VALUE_MODAL_EN_US: BlockedValueModalTranslations = {
	title: "Blocked Value",
	description: "What are blocked values?",
	descriptionText:
		"Blocked values are amounts temporarily unavailable due to security policies or transaction processing.",
	totalSummary: "Total Summary",
	liquidationDate: "LIQUIDATION DATE",
	competenceDate: "COMPETENCE DATE",
	receivableType: "RECEIVABLE TYPE",
	contractEffectType: "CONTRACT EFFECT TYPE",
	observation: "OBSERVATION",
	value: "VALUE",
	receivableTypes: {
		credit: "Credit",
		debit: "Debit",
	},
	blockCategories: {
		"Transferência de titularidade": "Ownership transfer",
		"Ônus - Cessão fiduciária": "Encumbrance - Fiduciary assignment",
		"Ônus - Outros": "Encumbrance - Others",
		"Bloqueio judicial": "Judicial block",
		"Promessa de Cessão": "Assignment promise",
		"Tipo desconhecido": "Unknown type",
	},
};
